import { Paper, Stack, Tabs, Text, Title } from '@mantine/core'
import YourBizPage from 'src/containers/YourBiz/YourBizPage'
import { useQueryParamTab } from 'src/utils/tabQueryParam'

const TabPlaceholder = ({
	title,
	description,
}: {
	title: string
	description: string
}) => {
	return (
		<Paper
			withBorder
			radius="md"
			p="lg"
			sx={{ background: '#ffffff', borderColor: '#e6ebe7' }}
		>
			<Stack spacing={6}>
				<Title order={4}>{title}</Title>
				<Text color="dimmed">{description}</Text>
			</Stack>
		</Paper>
	)
}

function ListYourBizPage() {
	const tabValues = ['your-biz', 'items', 'business'] as const
	const { activeTab, handleTabChange } = useQueryParamTab(tabValues, 'your-biz')

	return (
		<Stack sx={{ width: '100%' }}>
			<Tabs value={activeTab} onTabChange={handleTabChange} keepMounted={false}>
				<Tabs.List>
					<Tabs.Tab value="your-biz" fw={700}>
						You BIZ
					</Tabs.Tab>
					<Tabs.Tab value="items" fw={700}>
						Items
					</Tabs.Tab>
					<Tabs.Tab value="business" fw={700}>
						Business
					</Tabs.Tab>
				</Tabs.List>

				<Tabs.Panel value="your-biz" pt="md">
					{/* <TabPlaceholder
						title="You BIZ"
						description="Manage and review your business profiles."
					/> */}
					<YourBizPage />
				</Tabs.Panel>

				<Tabs.Panel value="items" pt="md">
					<TabPlaceholder
						title="Items"
						description="Track items and their listing information."
					/>
				</Tabs.Panel>

				<Tabs.Panel value="business" pt="md">
					<TabPlaceholder
						title="Business"
						description="Browse business-level settings and statistics."
					/>
				</Tabs.Panel>
			</Tabs>
		</Stack>
	)
}

export default ListYourBizPage
